export * from './screen-size.service';
export * from './screen-size.service.interface';
